import { primitiveColors } from '../colors';
import { ComponentColors } from '../component-colors';
import { semanticColors } from './semantic-colors';

export const componentColors: ComponentColors = {
    alert: {
        bg: semanticColors.background.subtle,
    },
    modals: {
        layerFigma: semanticColors.background.alternative,
        network: { accent: semanticColors.foreground.accent },
        priceZone: { fgMapNumbers: semanticColors.foreground.alternative },
    },
    rolePill: {
        fgGuest: primitiveColors.urbanOrange[500],
        fgSwapAndOwner: primitiveColors.skydome[500],
        borderSwapAndOwner: semanticColors.foreground.accent,
        fgFavorite: primitiveColors.gray[500],
    },
    controls: {
        checkbox: { bgActive: semanticColors.foreground.accent },
        toggle: { bgActive: semanticColors.background.accent },
        radioButton: { fgActive: semanticColors.foreground.accent },
        slider: {
            fgAmount: semanticColors.foreground.accent,
            fgTotalAmount: semanticColors.foreground.subtle,
            fgIcons: semanticColors.foreground.subtle,
        },
    },
    chargerStatus: {
        fgDisabled: semanticColors.foreground.disabled,
        fgIconDisabled: semanticColors.background.disabled,
        loadingIconSecondary: primitiveColors.gray.fff,
        fgNotAvailable: semanticColors.foreground.subtle,
    },
    avatar: {
        bgColoredIcon: semanticColors.background.accent,
        bgColoredInitials: semanticColors.background.accent,
    },
    toggleButton: {
        withText: {
            borderDefault: semanticColors.border.accent,
            fgDefault: semanticColors.foreground.accent,
            bgSelected: semanticColors.background.accent,
            fgSelected: semanticColors.foreground.light,
        },
        withIcon: {
            bg: semanticColors.background.alternative,
        },
    },
    button: {
        primary: {
            bgDefault: semanticColors.background.accent,
            fgDefault: semanticColors.foreground.light,
            bgAlternativeDefault: semanticColors.background.subtle,
            fgAlternativeDefault: semanticColors.foreground.default,
        },
        secondary: {
            borderDefault: semanticColors.border.default,
            fgDefault: semanticColors.foreground.default,
            fgAlternativeDefault: semanticColors.foreground.light,
        },
        important: {
            bgImportant: semanticColors.background.subtle,
            fgImportant: semanticColors.foreground.error,
        },
    },
    card: {
        error: {
            bgError: semanticColors.background.subtle,
            fgError: semanticColors.foreground.error,
        },
        alternative: {
            bgAlternative: semanticColors.background.default,
        },
    },
    tab: {
        fgActive: semanticColors.foreground.secondaryControls,
    },
    connectorState: {
        bgUnavailable: primitiveColors.gray[850],
    },
};
